module.exports = __webpack_public_path__ + "img/horizontal_3_1_9005.56b224ce.png";